@let smallBreak = breakpointObserverSmall | async;


<div class="w-full flex justify-center text-lg">
    <div [ngClass]="smallBreak?.matches ? 'small' : 'full'">
        <app-form-response class="w-full" [responseId]="id()"></app-form-response>
    </div>
</div>